import axios from '@/api/config';

const pageWidgetRelation = {

    getPageWidgetRelationList(data) {
        return axios.get(`${process.env.BASE_URL}/pageWidgetRelation/getIndexPageWidgetRelation`, { params: data });
    },
    updatePageWidgetRelation(data) {
        return axios.put(`${process.env.BASE_URL}/pageWidgetRelation/updatePageWidgetRelation`, data);
    },
}

export default pageWidgetRelation;



// WEBPACK FOOTER //
// ./src/api/pageWidgetRelation.js